const ja = {
  title: "通知受信設定",
  name: "受信者名",
  email: "メールアドレス",
  phone: "携帯電話番号",
  emailType: "通知カテゴリ",
  groups: "グループ",
  search: "検索",
  reset: "リセット",
  addReveiver: "受信者の追加",
  action: "操作",
  selectReceiverType: "受信者タイプ",
  // isOperator: '请选择系统操作员',
  perator: "担当者",
  noOperator: "非オペレーター",
  basicInfo: "基本情報",
  operatorName: "担当者名",
  operatorEmail: "担当者のメールアドレス",
  operatorPhone: "担当者の携帯電話",
  receiverName: "受信者名",
  receiverEmail: "メールアドレス",
  receiverPhone: "携帯電話番号",
  seeAll: "全て",
  edit: "編集",
  delete: "削除",
  deleteTip: "このメッセージ受信者を削除してもよろしいですか?",
  editReceiver: "受信者の編集",
  msgType: "通知カテゴリ",
  allMsgtype: "すべての通知カテゴリ",
  futureMsgType: "このオプションをチェックすると、今後追加される新しいメッセージ タイプがデフォルトで追加されるため、手動で再度追加する必要はありません。",
  futureNewGroup: "※このオプションにチェックを入れると、今後作成されるグループもデフォルトで対象となるため、手動で追加する必要はありません。",
  selectAll: "すべて選択",
  group: "グループ",
  allGroups: "全グループ",
  groupTip: "受信者は、指定されたグループの通知のみを受信します。",
  groupNotSelected: "未選択",
  groupSelected: "選択済み",
  add: "新規追加",
  comfirm: "確認する",
  cancel: "キャンセル",
  editeReveiver: "編集を保存する",
  modifySuccess: "パスワードの再設定が完了しました",
  modifyFail: "変更に失敗しました",
  addSuccess: "正常に追加されました",
  addFail: "追加に失敗しました",
  deleteSuccess: "正常に削除されました",
  typeIncludes: "このカテゴリに含まれる通知：",
  pickOneMsg: "少なくとも 1 つのメッセージ タイプを選択してください",
  pickOneGroup: "少なくとも 1 つのグループを選択してください"
};
export default ja;
